module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/2-5021e24cb32eb98fce8566ef5e2835bc.svg";